import { Injectable } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Cop } from "../../shared/models/cop";

@Injectable({
  providedIn: "root",
})
export class CopService {
  constructor(private http: HttpClient) {}

  apiRoot = `${environment.apiUrl}Cop`;

  public createCop(code: string, description: string): Observable<Cop> {
    return this.http.post<Cop>(
      `${this.apiRoot}/createDiscipline/code=${code}/description=${description}`,
      null
    );
  }

  public getCop(code: string): Observable<Cop> {
    return this.http.get<Cop>(`${this.apiRoot}/getCop/${code}`);
  }

  public getAllCops(): Observable<Cop[]> {
    return this.http.get<Cop[]>(`${this.apiRoot}/getAllCops`);
  }

  public deleteCop(code: string): Observable<Cop> {
    return this.http.delete<Cop>(`${this.apiRoot}/deleteCop/${code}`);
  }
}
